import { Component } from '@angular/core';
import { ConfigService } from "../../../shared/services/config.service";
import { ToastrService } from "ngx-toastr";
import AppShareHelper from "../../../shared/utils/helper";

@Component({
    selector: 'app-popup-management',
    templateUrl: './popup-management.html',
})
export class PopupManagement  {
    popupModel: any = {
        KeyName : ''
    }
    modelId = null;
    formValid = true;
    type = 'popup';
    loaded = false;
    
    constructor(public configService: ConfigService, public toastr : ToastrService) {
    }
    
    ngOnInit() {
        this.configService.getConfig(this.type).subscribe((res: any) => {
            if (res.Data && res.Data.length) {
                this.popupModel = res.Data[0].data;
                this.popupModel.Config = JSON.stringify(this.popupModel.Config);
                this.modelId = res.Data[0].id;
            }
            this.loaded = true;
        })
    }
    
    update(form) {
        try {
            const cloneModel = AppShareHelper.deepClone(this.popupModel);
            cloneModel.Config = JSON.parse(this.popupModel.Config);
            const params = {
                type : this.type,
                data : cloneModel
            }
    
            if (this.modelId) {
                this.configService.updateConfig(this.modelId, params).subscribe((res) => {
                    this.toastr.success('Update config successfully', 'SUCCESS');
                })
            } else {
                this.configService.saveConfig(params).subscribe((res: any) => {
                    this.toastr.success('Update config successfully');
                    this.modelId = res.Data.id;
                })
            }
        } catch (error) {
            this.toastr.error('Invalid params', 'ERROR');
        }
      
    }
    
    tooltip(tooltip, $event) {
        $event.stopPropagation();
        if (tooltip.isOpen()) {
            tooltip.close();
        } else {
            tooltip.open();
        }
    }
}
